import type { ChannelConfigField, IResolvedChannelConfig } from '@/app/voter-interaction/messaging/channels';
import type { IApiResponse } from '@/helpers/types';

import { coreApiSlice } from '../apiSlice';

export type { IResolvedChannelConfig };

export type IUpsertChannelConfig = { partyId: number; candidateId?: number | null } & Record<ChannelConfigField, boolean>;

const CONFIG_PATH = '/Party/channel-configuration';

export const channelConfigApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		// Super-admin admin read: the exact row for this party (+ optional candidate override).
		getChannelConfig: builder.query<IApiResponse<IResolvedChannelConfig>, { partyId: number; candidateId?: number | null }>({
			query: ({ partyId, candidateId }) => ({
				url: CONFIG_PATH,
				params: candidateId != null ? { partyId, candidateId } : { partyId },
			}),
		}),
		// Effective config the voter-interaction wizard reads to gate channels
		// (candidate override → party default fallback resolved server-side).
		getResolvedChannelConfig: builder.query<
			IApiResponse<IResolvedChannelConfig>,
			{ partyId: number; candidateId?: number | null }
		>({
			query: ({ partyId, candidateId }) => ({
				url: `${CONFIG_PATH}/resolved`,
				params: candidateId != null ? { partyId, candidateId } : { partyId },
			}),
		}),
		upsertChannelConfig: builder.mutation<IApiResponse<IResolvedChannelConfig>, IUpsertChannelConfig>({
			query: (body) => ({
				method: 'PUT',
				url: CONFIG_PATH,
				body,
			}),
		}),
	}),
});

export const {
	useGetChannelConfigQuery,
	useGetResolvedChannelConfigQuery,
	useLazyGetResolvedChannelConfigQuery,
	useUpsertChannelConfigMutation,
} = channelConfigApiSlice;
